<template>
  <div>
    <div v-if="$store.state.mobile">
      <v-card
        elevation="0"
        class="mb-4"
        rounded="lg"
      >
        <div class="d-flex align-center pa-3">
          <v-icon size="40">
            mdi-account-circle
          </v-icon>
          <div class="ms-3 text-h4">
            {{ $store.state.user.email }}
          </div>
        </div>
      </v-card>
      <v-card
        elevation="0"
        rounded="lg"
        class="mb-4"
        :to="{name: 'CartList'}"
      >
        <v-container>
          <v-row
            no-gutters
          >
            <v-col
              cols="auto"
              class="pe-3"
            >
              <v-icon size="40">
                mdi-shopping
              </v-icon>
            </v-col>
            <v-col>
              <div class="text-h4 line-height-sm">
                <template v-if="$store.getters.languageGetter === '1'">
                  عربة التسوق
                </template>
                <template v-else>
                  Shopping Cart
                </template>
              </div>
              <div class="grey--text">
                {{ $store.state.cart.cartList.data.length }}
                <template v-if="$store.getters.languageGetter === '1'">
                  العناصر
                </template>
                <template v-else>
                  items
                </template>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card
        elevation="0"
        rounded="lg"
        class="mb-4"
      >
        <v-card-title class="text-h4">
          <template v-if="$store.getters.languageGetter === '1'">
            انتظار الدفع
          </template>
          <template v-else>
            Awaiting Payment
          </template>
        </v-card-title>
        <v-card-text>
          <template v-for="(item,i) in awaitingPayment">
            <v-divider
              :key="i"
            />
            <v-card
              :key="item.id"
              tile
              elevation="0"
              color="grey lighten-5 mb-2"
            >
              <v-container class="pt-0">
                <v-row>
                  <v-col
                    v-for="detail in item.detail"
                    :key="detail.id"
                    style="max-width:20%"
                  >
                    <v-card
                      outlined
                      tile
                    >
                      <v-img
                        :src="detail.image"
                        aspect-ratio="1"
                        contain
                        class="grey lighten-5"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey"
                            />
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <div class="d-flex align-center">
                  <router-link
                    :to="{name: 'UserOrderDetail', params: {id: item.id}}"
                    class="grey--text me-auto"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      عرض التفاصيل
                    </template>
                    <template v-else>
                      View Detail
                    </template>
                  </router-link>
                  $ <span class="text-h4 ms-1 me-2">{{ item.amount }}</span>
                  <v-btn
                    color="#f51414"
                    depressed
                    small
                    dark
                    :to="{name: 'UserOrderDetail', params: {id: item.id}}"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      ادفع الآن
                    </template>
                    <template v-else>
                      Pay Now
                    </template>
                  </v-btn>
                </div>
              </v-container>
            </v-card>
          </template>
          <div
            v-if="orderList.unpayed.data.items.length > 1"
            class="text-center"
          >
            <v-btn
              small
              icon
              color="grey"
              @click="toggle = !toggle"
            >
              <v-icon>{{ toggle ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down' }}</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
      <v-divider />
      <v-list
        dense
        class="grey lighten-5"
      >
        <template v-for="(menu, i) in menus">
          <v-list-item
            :key="menu.text"
            :to="menu.url"
            class="ps-0"
          >
            <v-list-item-avatar tile>
              <v-icon v-text="menu.icon" />
            </v-list-item-avatar>
            <v-list-item-title>{{ menu.text }}</v-list-item-title>
            <v-list-item-action>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="i" />
        </template>
        <v-btn
          large
          block
          depressed
          color="white"
          class="mt-4 grey--text text--darken-1"
          @click="logOut"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            تسجيل الخروج من الحساب
          </template>
          <template v-else>
            Sign Out
          </template>
        </v-btn>
      </v-list>
    </div>
    <template v-else>
      <div class="d-flex align-center mb-4">
        <div class="me-auto">
          <div class="font-medium">
            <span class="text-h3"><template v-if="$store.getters.languageGetter === '1'">
                                    أهلا بك،
                                  </template>
              <template v-else>
                Welcome,
              </template></span><span class="text-h4">{{ $store.state.user.email }}</span>
          </div>
          <v-divider style="border-width:3px;border-color:#f1f2f6;min-width:350px" />
          <div class="grey--text mt-1">
            <template v-if="$store.getters.languageGetter === '1'">
              تسوق سعيد ، حياة سعيدة.
            </template>
            <template v-else>
              Happy shopping, happy living.
            </template>
          </div>
        </div>
        <div class="text-center d-flex align-center">
          <router-link
            :to="{name: 'UserOrderList', params: {active: 1}}"
            class="mx-4"
          >
            <v-badge
              :value="+orderList.unpayed.data.totalItem"
              :content="orderList.unpayed.data.totalItem"
              right
              overlap
              color="#f16056"
            >
              <v-icon
                size="30"
                color="primary"
              >
                mdi-clipboard-text-play
              </v-icon>
            </v-badge>
            <div>
              <template v-if="$store.getters.languageGetter === '1'">
                انتظار الدفع
              </template>
              <template v-else>
                Awaiting Payment
              </template>
            </div>
          </router-link>
          <router-link
            :to="{name: 'UserOrderList', params: {active: 2}}"
            class="mx-4"
          >
            <v-badge
              :value="+orderList.shipped.data.totalItem"
              :content="orderList.shipped.data.totalItem"
              right
              color="#f16056"
              overlap
            >
              <v-icon
                size="30"
                color="primary"
              >
                mdi-truck
              </v-icon>
            </v-badge>
            <div>
              <template v-if="$store.getters.languageGetter === '1'">
                تم شحن الشحنة
              </template>
              <template v-else>
                Shipment Shipped
              </template>
            </div>
          </router-link>
          <router-link
            :to="{name: 'UserOrderList', params: {active: 3}}"
            class="mx-4"
          >
            <v-icon
              size="30"
              color="primary"
            >
              mdi-file-document-box-remove
            </v-icon>
            <div>
              <template v-if="$store.getters.languageGetter === '1'">
                ألغيت
              </template>
              <template v-else>
                Canceled
              </template>
            </div>
          </router-link>
          <router-link
            :to="{name: 'UserOrderList', params: {active: 4}}"
            class="ms-4"
          >
            <v-icon
              size="30"
              color="primary"
            >
              mdi-clipboard-check
            </v-icon>
            <div>
              <template v-if="$store.getters.languageGetter === '1'">
                مكتمل
              </template>
              <template v-else>
                Completed
              </template>
            </div>
          </router-link>
        </div>
      </div>
      <v-divider />
      <v-row class="d-block mt-4">
        <TabGoods
          :outlined="false"
          :menus="[0,-1,2]"
        />
      </v-row>
    </template>
  </div>
</template>

<script>
import TabGoods from '@/components/TabGoods.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UserDashboard',
  components: {
    TabGoods,
  },
  data() {
    return {
      showLength: 1,
      toggle: false,
    };
  },
  computed: {
    ...mapState('center', ['orderList']),
    menus() {
      return [
        {
          url: { name: 'UserOrderList' },
          text: this.$store.getters.languageGetter === '1' ? 'طلباتي' : 'My Orders',
          icon: 'mdi-clipboard-text-outline',
        },
        {
          url: { name: 'UserFavoriteList' },
          text: this.$store.getters.languageGetter === '1' ? 'مفضلتي' : 'My Favorites',
        },
        {
          url: { name: 'UserAddressList' },
          text: this.$store.getters.languageGetter === '1' ? 'دليل العناوين' : 'Address book',
        },
        {
          url: { name: 'UserAccountSettings' },
          text: this.$store.getters.languageGetter === '1' ? 'إعدادات الحساب' : 'Account Settings',
        },
      ];
    },
    awaitingPayment() {
      return this.orderList.unpayed.data.items.slice(0, this.toggle ? this.orderList.unpayed.data.items.length : this.showLength);
    },
    // toggle() {
    //   return this.showLength < this.orderList.unpayed.data.items.length - 1;
    // },
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions('center', ['getOrderListAsync']),
    ...mapActions(['logOutAsync']),
    loadPageData() {
      this.loading = true;
      const promises = [];
      if (!this.orderList.unpayed.status) {
        promises.push(this.getOrderListAsync({
          p: this.orderList.unpayed.data.p, dStatus: '1', operate: '0', sortType: '2', target: 'unpayed',
        }));
      }
      if (!this.orderList.shipped.status) {
        promises.push(this.getOrderListAsync({
          p: this.orderList.shipped.data.p, dStatus: '8', operate: '0', sortType: '2', target: 'shipped',
        }));
      }
      Promise.all(promises).finally(() => {
        this.loading = false;
      });
    },
    logOut() {
      this.$store.commit('SET_MINI_LOADING');
      this.logOutAsync().finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
    submitForm() {
      this.$store.commit('SET_MINI_LOADING');
      console.log(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.num {
  position: absolute;
  right: -15px;
  top: -15px;
}
</style>
